export const toStripeMoney = (amount: number) => (
  parseInt((parseFloat(String(amount)) * 100).toFixed(2), 10)
)

export default toStripeMoney
